// extracted by mini-css-extract-plugin
export var button = "_ec-4";
export var hasDarkBackground = "_ec-7";
export var hasLightBackground = "_ec-6";
export var iconWrapper = "_ec-0";
export var large = "_ec-2";
export var medium = "_ec-1";
export var small = "_ec-5";
export var xsmall = "_ec-3";